<template>
    <div class="more-fixed">
        <div v-for="(item, index) in options" :key="index" style="padding: 0.2rem;">
            <el-tag type="primary" effect="dark" size="mini" v-for="(v,i) in item" :key="i" style="margin-right: 0.2rem">
                {{ Array.isArray(v) ? v.join('') : v }}
            </el-tag>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MoreFixed',
    props: {
        options: {
            type: Array
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/MoreFixed.vue